module.exports = __webpack_public_path__ + "static/media/customers3.54017e78.png";